import React, { useCallback, useEffect, useState } from 'react';
import { ITransportadorasVeiculos, Options, Veiculos } from '../types/types';
import SelectCustom from '../../../../../../../../components/SelectCustom';
import { useFormik } from 'formik';
import Loading
  from '../../../../../../../../core/common/Loading';
import { ToastContainer } from 'react-toastify';
import api from '../../../../../../../../services/api';
import formValidator from './validators/formValidator';
import { toast } from 'sonner';
import ChoiceBox from '../../../../../../OperacoesPatio/Triagens/Create/Scheduling/components/shared/ChoiceBox';
import InputCustom from '../../../../../../../../components/InputCustom';
import { useAuth } from '../../../../../../../../hooks/AuthenticateContext';

interface FormValues {
  id_transportadora: number;
  placa: string;
  faturamento_temporario: string;
  numero_faturamento_temporario: string;
}

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  selectedRow?: ITransportadorasVeiculos;
  id_transportadora?: number;
  onConfirm: () => void;
  onClose: () => void;
}

const Form: React.FC<Props> = (props: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [,setPlates] = useState<Options[]>([]);
  const [, setSearchQuery] = useState<string>("");
  const { user } = useAuth();

   const [choiceOptions, setChoiceOptions] = useState([
    {
      id: 1,
      label: "Faturamento Temporário",
    },
  ]);


  const handleSubmit = useCallback(async (values: FormValues) => {
    try {
      setLoading(true);


      const rawBody = {
        id_transportadora: props.isEdit ? props.selectedRow?.id_transportadora : props.id_transportadora,
        id_transportadora_veiculo: props.isEdit ? props.selectedRow?.id_transportadora_veiculo : null,
        placa: values.placa.replaceAll(".", "").replaceAll("-", "").replace("/", ""),
        faturamento_temporario: values.faturamento_temporario === '1' ? Number(values.numero_faturamento_temporario) : null,
        id_usuario_historico: user?.id,
      }
      const body = Object.entries(rawBody).reduce((acc: any, [key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});

      if (props.isEdit) {
        const response = await api.post("/editar/transportadorasVeiculos", body);

        if (response.status === 200) {
          toast.success("Veiculo salvo na transportadora com sucesso!");
          props.onConfirm();
        } else {
          toast.error("Erro ao salvar o veiculo na transportadora!");
        }
      } else {
        const response = await api.post("/cadastrar/transportadorasVeiculos", body);

        if (response.status === 200) {
          toast.success("Veiculo salvo na transportadora com sucesso!");
          props.onConfirm();
        } else {
          toast.error("Erro ao salvar o veiculo na transportadora!");
        }
      }

      setLoading(false);
    } catch {
      toast.error("Erro ao salvar o veiculo na transportadora!");
      setLoading(false);
    }
  }, [props.isEdit, props.selectedRow, props.id_transportadora, user, props.onConfirm]);

  const onLoadFormValues = useCallback((row?: ITransportadorasVeiculos) => {
    const data = row;

    console.log(data);

    if (data) {
      formik.setFieldValue("placa", String(data.placa_dianteira_veiculo));
      loadOptions(String(data.placa_dianteira_veiculo), null);

      console.log(data);

      if (data.faturamento_temporario !== null) {
        formik.setFieldValue("faturamento_temporario", "1");
        formik.setFieldValue("numero_faturamento_temporario", String(data.faturamento_temporario));
      } else {
        formik.setFieldValue("faturamento_temporario", "0");
        formik.setFieldValue("numero_faturamento_temporario", '');
      }
    }
  }, []);

  const initialValues: FormValues = {
    placa: "",
    id_transportadora: props.selectedRow ? props.selectedRow.id_transportadora : 0,
    faturamento_temporario: "0",
    numero_faturamento_temporario: '',
  };

  const formik = useFormik({
    initialValues,
    validationSchema: formValidator,
    onSubmit: (values: FormValues) => {
      handleSubmit(values);
    },
  });

  console.log(formik.values.faturamento_temporario);

  const getPlates = useCallback(async (plate?: string) => {
    try {
      let body: any = {
        order_by: "data_historico",
        order_direction: "desc",
        qtd_por_pagina: 20
      }

      if(plate) {
        body = {
          ...body,
          placa: plate,
        }
      }

      const response = await api.post("/listar/veiculos", body);

      const mappingResponse = response.data.data.map((item: Veiculos) => {
        return {
          value: item.placa,
          label: item.placa,
        };
      });

      setPlates(mappingResponse);

      return mappingResponse;
    } catch (error) {
      console.error("Failed to fetch plates:", error);
    }
  }, []);

   const loadOptions = async (inputValue: string, callback: any) => {
    if (inputValue.length < 3) {
      // Não carrega nada se menos de 3 caracteres
      callback([]);
      return;
    }

    return await getPlates(inputValue);
  };

  useEffect(() => {
    getPlates();
  }, [getPlates]);

  useEffect(() => {
    console.log(props.isEdit);
    if (props.isView || props.isEdit) {
      onLoadFormValues(props.selectedRow);
    }
  }, [props.isEdit]);
  return (
    <>
      <Loading loading={loading} skeletonFields={2} skeletonColumns={2} />

      <ToastContainer />
      <div className="overflow-y-scroll max-w-full max-h-[550px] p-5">
        <div className="grid grid-cols-2 gap-3 mb-2">
          <div>
            <SelectCustom
              async
              data={loadOptions}
              onChange={(selectedOption: Options) => {
                formik.setFieldValue("placa", String(selectedOption.value));
                // getPlates();
              }}
              onInputChange={(inputValue: string) => {
                setSearchQuery(inputValue);
              }}
              title="Placa"
              touched={formik.touched.placa}
              error={formik.errors.placa}
              disabled={props.isView}
              value={formik.values.placa}
            />
          </div>

        </div>

        <ChoiceBox
            data={choiceOptions}
            onChange={(value: number) => {
              setChoiceOptions([
                  {
                    id: 1,
                    label: "Faturamento Temporário",
                  },
                ]);

                console.log(value);
              
                formik.setFieldValue("faturamento_temporario", formik.values.faturamento_temporario === "1" ? String(0) : String(value));
                
            }}
            value={formik.values.faturamento_temporario}
          />
          {formik.values.faturamento_temporario === "1" && (
            <div className='mt-4 w-1/2'>
              <InputCustom
                title="Faturamento Temporário"
                placeholder='Número de faturamento'
                type="number"
                
                name="faturamento_temporario"
                onChange={(value: any) => {
                  formik.setFieldValue("numero_faturamento_temporario", String(value));
                }}
                value={formik.values.numero_faturamento_temporario}
                touched={formik.touched.numero_faturamento_temporario}
                error={formik.errors.numero_faturamento_temporario}
                disabled={props.isView}
              />
            </div>
          )}
      </div>
      <div className="w-full h-14 flex items-center justify-end bg-[#FFFFFF] shadow-xl">
        <button
          type="button"
          className="w-24 h-9 pl-3 pr-3 flex items-center justify-center bg-[#F9FAFA] text-sm text-[#000000] font-bold rounded-full mr-2"
          style={{ border: "1px solid #DBDEDF" }}
          onClick={props.onClose}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="w-24 h-9 pl-3 pr-3 flex items-center justify-center bg-[#0A4984] text-sm text-[#fff] font-bold rounded-full mr-2"
          onClick={() => formik.handleSubmit()}
        >
          Salvar
        </button>
      </div>
    </>
  )
}

export default Form;